module.exports = __webpack_public_path__ + "img/no_jurisdiction.5b2e346a.png";